import styled, { css } from 'styled-components';
import { neutralWhite } from '../themes/colors';
import { Loader } from '../loader';
import { Button } from '../button';

const StyledFooter = styled.div<{
	$large?: boolean,
}>`
	display: flex;
	justify-content: space-between;
	padding: 20px;
	gap: 12px;
	${props => props.$large && css`
		width: fit-content;
		margin-left: auto;
	`}
	& > ${Button.cssSelector} {
		flex: 0 1 50%;
	}

	${Loader.cssSelector} {
		border-top-color: ${neutralWhite};
		border-left-color: ${neutralWhite}
	}
`;

export function Footer({ onSave, onClose, isSaving, disableButtons = false, cancelText, saveText, large }: {
	onSave: () => void,
	onClose: () => void,
	isSaving?: boolean,
	disableButtons?: boolean,
	cancelText: string,
	saveText: string,
	large?: boolean,
}) {
	return <StyledFooter $large={large} className={'slide-in-footer'}>
		<Button 
			variant='secondary'
			onClick={onClose}
			disabled={disableButtons}
			label={cancelText}
		/>
		<Button 
			variant='primary'
			onClick={onSave}
			disabled={isSaving || disableButtons}
		>
			{isSaving ? <Loader /> : saveText}
		</Button>
	</StyledFooter>;
}
